(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["juno-reference-currency"] && !Shopify.designMode) return;
  try {
    (() => {
      const bar = document.getElementById('juno-reference-currency');
      if (!bar) return;
      const selects = Array.from(document.querySelectorAll('[data-juno-currency-select]'));
      if (!selects.length) return;
      const status = document.getElementById('juno-reference-currency-status');
      const details = bar.querySelector('details');
      const country = bar.dataset.country;
      const preferencesKey = 'juno-reference-currency-v1';
      const ratesKey = 'juno-reference-rates-v1';
      const defaults = { HK: 'HKD', TW: 'TWD', SG: 'SGD', MY: 'MYR', TH: 'THB', US: 'USD', AU: 'AUD', CA: 'CAD', GB: 'GBP', JP: 'JPY', CN: 'CNY', DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', IE: 'EUR', PT: 'EUR', AT: 'EUR', BE: 'EUR', FI: 'EUR', GR: 'EUR', EE: 'EUR', LV: 'EUR', LT: 'EUR', LU: 'EUR', MT: 'EUR', SK: 'EUR', SI: 'EUR', CY: 'EUR', HR: 'EUR' };
      const read = (key) => { try { return JSON.parse(localStorage.getItem(key)); } catch { return null; } };
      const write = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch {} };
      const preference = read(preferencesKey);
      let currency = preference && preference.country === country ? preference.currency : defaults[country] || 'USD';
      if (!Array.from(selects[0].options).some(option => option.value === currency)) currency = 'USD';
      selects.forEach(select => { select.value = currency; });
      let data = read(ratesKey);
      let pending;
      const maxAge = 48 * 60 * 60 * 1000;
      const valid = (value) => value && value.base_code === 'HKD' && value.result === 'success' && Number.isFinite(value.time_last_update_unix) && Date.now() - value.time_last_update_unix * 1000 < maxAge && value.rates && Number.isFinite(value.rates[currency]) && value.rates[currency] > 0;
      const originals = new WeakMap();
      const moneyPattern = /(?:HK\$|HKD\s*\$?)\s*([\d,]+(?:\.\d+)?)/;
      const observer = new MutationObserver(() => schedule());
      let queued = false;
      const locale = bar.dataset.language || 'en';
      const placeNotice = () => {
        if (!bar.classList.contains('juno-reference-currency--product')) return;
        const price = document.querySelector('#MainContent .price-item')?.closest('.price');
        const host = price?.parentElement;
        if (!host) return;
        host.classList.add('juno-price-with-reference');
        if (bar.parentElement !== host) host.append(bar);
      };
      const watch = () => observer.observe(document.getElementById('MainContent'), { subtree: true, childList: true, characterData: true });
      const render = () => {
        observer.disconnect();
        placeNotice();
        document.querySelectorAll('#MainContent .price-item').forEach(element => {
          let original = originals.get(element);
          if (!original || element.textContent !== original.rendered) original = { text: element.textContent };
          const match = original.text.match(moneyPattern);
          if (!match) return;
          const amount = Number(match[1].replaceAll(',', ''));
          if (!Number.isFinite(amount)) return;
          if (currency === 'HKD' || !valid(data)) {
            if (element.textContent !== original.text) element.textContent = original.text;
          } else {
            const primary = document.createElement('span');
            primary.textContent = original.text.trim().replace(moneyPattern, '≈ ' + new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'code', maximumFractionDigits: currency === 'JPY' || currency === 'TWD' ? 0 : 2 }).format(amount * data.rates[currency]));
            const base = document.createElement('small');
            base.className = 'juno-reference-price-hkd';
            base.textContent = new Intl.NumberFormat(locale, { style: 'currency', currency: 'HKD', currencyDisplay: 'code' }).format(amount);
            element.replaceChildren(primary, base);
          }
          original.rendered = element.textContent;
          originals.set(element, original);
        });
        watch();
      };
      const schedule = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; render(); });
      };
      const update = async () => {
        details.hidden = currency === 'HKD';
        if (currency === 'HKD') { schedule(); return; }
        if (!valid(data) || Date.now() > data.time_next_update_unix * 1000) {
          if (!pending) {
            pending = fetch('https://open.er-api.com/v6/latest/HKD', { credentials: 'omit', referrerPolicy: 'no-referrer', signal: AbortSignal.timeout(8000) })
              .then(response => { if (!response.ok) throw new Error('rate'); return response.json(); })
              .then(result => { if (valid(result)) { data = result; write(ratesKey, result); } })
              .catch(() => {})
              .finally(() => { pending = null; });
          }
          await pending;
        }
        status.textContent = valid(data) ? bar.dataset.updated + ' ' + new Date(data.time_last_update_unix * 1000).toLocaleDateString(locale) : bar.dataset.error;
        schedule();
      };
      selects.forEach(select => select.addEventListener('change', () => {
        currency = select.value;
        selects.forEach(control => { control.value = currency; });
        write(preferencesKey, { country, currency });
        update();
      }));
      watch();
      update();
    })();
  } catch(e) { console.error(e); }
})();

})();
